module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-laugh-svgrepo-com.8036535d.svg";